export default __webpack_public_path__ + "static/media/focused.07444437.gif";